import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {User} from 'app/auth/models';

import {environment} from 'environments/environment';
import {IPageableResponse} from '../../global/pagging.dto';

export interface IUsersAutocomplete {
  id: number;
  name: string;
  email: string;
}

export interface IGetSubusers {
    id: number;
    name:string;
}


@Injectable({ providedIn: "root" })
export class UserService {
  /**
   *
   * @param {HttpClient} _http
   */
  constructor(private _http: HttpClient) {}

  /**
   * Get all users
   */
  getAll() {
    return this._http.get<User[]>(`${environment.apiUrl}/users`);
  }

  /**
   * Fetching current workspace users
   * For sending self means also getting logged in user 
   * @param self 
   * @returns 
   */
  getSubUsers(self: boolean = false) {
    return this._http.get<IGetSubusers[]>(`users/sub-users?self=${self}`);
  }

  /**
   * Get user by id
   */
  getById(id: number) {
    return this._http.get<User>(`${environment.apiUrl}/users/${id}`);
  }

  usersAutocomplete(
    skip_logged_user?: boolean,
    search?: string,
    page?: number
  ) {
    let httpParams = new HttpParams();

    if (search && search?.trim().length > 0) {
      httpParams = httpParams.set("search", search);
    }

    if (page) {
      httpParams = httpParams.set("page", page);
    }

    if (skip_logged_user) {
      httpParams = httpParams.set(
        "skip_logged_user",
        skip_logged_user === true ? 1 : 0
      );
    }

    return this._http.get<IPageableResponse<IUsersAutocomplete>>(
      `users/autocomplete`,
      {
        params: httpParams,
      }
    );
  }
}
